import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import Logo from 'src/components/Logo';
import responsive from 'src/constants/responsive';
import { Subtract } from 'utility-types';
import { InjectedPagesProps, withPages } from './Pages';

const styles = {
    container: {
        position: 'relative',
        width: '200vw',
        height: '100%',
        [responsive.Mobile]: {
            '&[data-position="pages"]': {
                transform: 'translate3d(0, 0, 0)'
            },
            '&[data-position="menu"]': {
                transform: 'translate3d(0, 0, 0)'
            },
            '&[data-position="detail"]': {
                transform: 'translate3d(0, 0, 0)'
            }
        },
        [responsive.AfterMobile]: {
            '&[data-position="pages"]': {
                transform: 'translate3d(-100vw, 0, 0)'
            },
            '&[data-position="menu"]': {
                transform: 'translate3d(-100vw, 0, 0)'
            },
            '&[data-position="detail"]': {
                transform: 'translate3d(0, 0, 0)'
            }
        }
    },
    animate: {
        transition: 'transform .8s ease',
    },
    logo: {
        [responsive.Mobile]: {
            display: 'none'
        },
        [responsive.Tablet]: {
            display: 'none'
        },
        [responsive.AfterTablet]: {
            position: 'absolute',
            left: '100vw',
            bottom: 0,
            transition: 'transform .8s ease',
            '[data-position="pages"] &': {
                transform: 'translate3d(0vw, 0, 0)'
            },
            '[data-position="detail"] &': {
                transform: 'translate3d(-100%, 0, 0)'
            }
        }
    },

};

export type transitionDirection = 'detail' | 'pages' | 'menu';
export type TransitionedContainer = {
    move: (direction: transitionDirection) => void;
    current: transitionDirection;
};

const initState: TransitionedContainer = {
    move: 0 as never,
    current: 0 as never
}
export const TransitionedContainerReactContext = React.createContext<TransitionedContainer>(initState);

export type TransitionedContainerProdiverProps = {};
type Props =
    InjectedPagesProps &
    TransitionedContainerProdiverProps &
    StyledComponentProps<keyof typeof styles>;

class TransitionedContainerProvider extends React.Component<Props, TransitionedContainer> {

    private container: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    private logo: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();
    constructor(props: Props) {
        super(props);

        this.state = {
            move: this._move.bind(this),
            current: 'detail'
        };
    }

    public render() {
        const { classes } = this.props;
        const { current } = this.state;
        return (
            <TransitionedContainerReactContext.Provider value={this.state}>
                <div
                    className={classes!.container}
                    ref={this.container}
                    data-position={current}
                >
                    {this.props.children}
                    <div
                        className={classes!.logo}
                        ref={this.logo}
                    >
                        <TransitionedContainerReactContext.Consumer>
                            {(p) => <Logo transitionedContainer={p} />}
                        </TransitionedContainerReactContext.Consumer>
                    </div>
                </div>

            </TransitionedContainerReactContext.Provider>
        );
    }

    private _move(dir: transitionDirection) {
        this.setState(() => ({ current: dir }), () => {
            if (this.container.current) {

                // this.container.current.dataset.position = dir;
                // animate only on second call
                setTimeout(() =>
                    this.container.current!.classList.add(this.props.classes!.animate!),
                    0);
            }
        });

    }
}

export type InjectedTransitionedContainerProps = { transitionedContainer: TransitionedContainer };
export const withTransitionedContainer =
    <OriginalProps extends InjectedTransitionedContainerProps>(
        Component: React.ComponentType<OriginalProps>
    ): React.FunctionComponent<Subtract<OriginalProps, InjectedTransitionedContainerProps>> => {

        return (props: Subtract<OriginalProps, InjectedTransitionedContainerProps>) => {
            return (
                <TransitionedContainerReactContext.Consumer>
                    {(transitionedContainer) =>
                        <Component {...{ ...(props as object), transitionedContainer } as OriginalProps} />}
                </TransitionedContainerReactContext.Consumer>
            );
        };

    };

export default withPages(withStyles(styles)(TransitionedContainerProvider));


// WEBPACK FOOTER //
// ./src/_context/TransitionedContainer.tsx